<template>
  <div>
    <!-- <SpaNav selectIndex="4"/> -->
    <PCNavbar selectIndex="4"/>
    <MobileNavBar :currentActive="4" />
    <ReportList></ReportList>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import SpaNav from '@/components/report_list/SpaNav.vue'
import ReportList from '@/components/report_list/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    SpaNav,
    ReportList
  },
}
</script>

<style>
</style>